import { createSlice, type PayloadAction } from "@reduxjs/toolkit";

/**
 * The legacy `assignmentSortSelections.json` sort options for the material cycle-count mission task
 * list, verbatim: Category / Item Id / Location / Product Name.
 */
export type CycleCountTaskSortField = "CATEGORY" | "ITEM_ID" | "LOCATION" | "PRODUCT_NAME";

export interface SettingsState {
	/** Authenticated user email, populated once a session is established (F3). */
	email: string;
	/** wsapi tenant id, derived from the JWT by the backend — never sent from the client. */
	tenantId: string;
	/**
	 * Persisted sort field for the material cycle-count assignment task list — legacy used a
	 * localStorage `savedValues` blob for the same purpose. Default matches legacy: Product Name.
	 */
	cycleCountTaskSortField: CycleCountTaskSortField;
}

const initialState: SettingsState = {
	email: "",
	tenantId: "",
	cycleCountTaskSortField: "PRODUCT_NAME"
};

const settingsSlice = createSlice({
	name: "settings",
	initialState,
	reducers: {
		updateSettings: (state, action: PayloadAction<Partial<SettingsState>>) => ({ ...state, ...action.payload })
	}
});

export const { updateSettings } = settingsSlice.actions;
export default settingsSlice.reducer;
